import Slider from './Slider'

export { getSliderStepByMaxValue } from './Slider'
export default Slider
